var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7997 15C16.4925 15 16.1853 14.8857 15.9514 14.6582L11.9855 10.8023L8.03397 14.5123C7.55638 14.9603 6.798 14.9487 6.33722 14.4832C5.87643 14.02 5.88963 13.2803 6.36602 12.8335L11.1659 8.32773C11.6375 7.88556 12.3863 7.89139 12.8482 8.34173L17.6481 13.0085C18.1173 13.4646 18.1173 14.202 17.6481 14.6582C17.4141 14.8857 17.1069 15 16.7997 15Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/ArrowUp.94e7729807da84997a010870ac2225fd.svg";
export { ForwardRef as ReactComponent };